import Mutations from '../../odata/mutations';

export default { ...new Mutations('email'), ...new Mutations('emails') };
